const basicWidth = '1200px';
const oneColor = '#55CCF9';
const twoColor = '#102a74';
const threeColor = '#f2f2f2';

const subtitleBottom = {
    paddingTop: 5,
    paddingBottom: 2.5,
    PaddingLeft: 1,
    PaddingRight: 1,
    '& .MuiTypography-root': {
        color: twoColor,
    }
}

const whatWeDoCard = {
    width: {xs: "32.3%", sm: "32.3%", md: "19.5%"},
    padding: "10px 0px",
    backgroundColor: 'transparent',
    border: 'none',
}

const parentBox = {
    display: "flex",
    width: "100%",
    justifyContent: 'center',
    alignItems: 'center',
}

const darkBlueBox = {
    backgroundColor: twoColor,
    '& .MuiTypography-root': {
        color: 'white',
    }
}


const whiteCopy = {
    '& .MuiTypography-root': {
        color: 'white',
    }
}

const testimonialBox = {

    width: {xs: '98%', sm: "48%", md: "98%"},
    boxSizing: 'border-box',
}

const lightBlueBox = {
    backgroundColor: oneColor,

}

const grayBox = {
    backgroundColor: threeColor,

}

const whiteBox = {
    backgroundColor: "white",
    '& .MuiTypography-root': {
        color: '#102a74',
    }

}

const basicSize = {
    width: basicWidth,
    display: "flex",
    justifyContent: 'center',
    flexDirection: {xs: 'column', sm: 'column', md: "row"},
    alignItems: "stretch",

}


const basicSizeReverse = {
    width: basicWidth,
    display: "flex",
    justifyContent: 'center',
    flexDirection: {xs: 'column-reverse', sm: 'column-reverse', md: "row"},
    alignItems: "stretch",


}

const fiftyFifty = {

    width: {xs: "100%", sm: "100%", md: "50%"},
    flexDirection: {xs: "column", sm: "column", md: "row"},
    display: 'flex',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    flexGrow: 1,
}

const fiftyFiftyHidden = {

    width: {xs: "100%", sm: "100%", md: "50%"},
    display: {xs: 'none', sm: 'none', md: 'flex'},
    backgroundSize: '200px auto, contain',
    backgroundPosition: 'calc(100% - 20px) calc(100% - 20px), center',
    backgroundRepeat: 'no-repeat',
    flexGrow: 1,
}

const beforeAfterImage = {

    height: "auto",
    width: {xs: "49%", sm: "32%", md: "49%"},

}

const oneHundred = {

    width: "100%",
    display: 'flex',
    flex: "100%",
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    flexGrow: 1,
}

const vCenter = {

    display: 'flex',
    flexDirection: 'column',
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
}

const vLeft = {

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',


}

const vRight = {

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    justifyContent: 'center',


}

const rightBottom = {

    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',


}

const hCenter = {

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    textAlign: 'center',
    flexWrap: 'wrap',


}

const hLeft = {

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',


}

const hRight = {

    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
}

const paddingMinimal = {

    boxSizing: "border-box",
    padding: 1.5,
    gap: 0.5,
}

const padding1 = {

    boxSizing: "border-box",
    padding: 5,
    gap: 2,
}

const padding2 = {

    boxSizing: "border-box",
    padding: 2,
    gap: 5,
}

const padding3 = {

    boxSizing: "border-box",
    padding: 1.5,
    gap: {xs: 10, sm: 10, md: 20},
}

const padding4 = {

    boxSizing: "border-box",
    padding: {xs: 2.5, sm: 2.5, md: 5},
    gap: {xs: 2, sm: 2, md: 3},
}

const marginEqualPadding4 = {

    boxSizing: "border-box",
    margin: {xs: 0, sm: 0, md: 5},
    gap: {xs: 2, sm: 2, md: 3},
}

const paddingForm = {

    boxSizing: "border-box",
    paddingTop: 5,
    paddingRight: 2,
    paddingBottom: 5,
    paddingLeft: 2,
    gap: 2,
}

const twoButton = {

    display: 'flex',
    alignItems: 'center',
}

const testimonialsStyle = {

    display: 'flex',
    flexWrap: 'wrap',
    gap: 2,
    justifyContent: 'center',
    justifyItems: 'center',
}

const youtubeVideo = {

    maxWidth: '600px',
    aspectRatio: '16/9',
    minWidth: '100%',

}

const guaranteeBox = {
    width: "22.5%",
    padding: 0,
    gap: "1 2",
    boxShadow: 'none',
    backgroundColor: 'transparent',
    border: 'none'
}

const marginBottomR = {
    marginBottom: 5,
}

const watchButton = {
    color: "white",
    fontWeight: "regular",
    backgroundColor: 'rgba(16, 42, 116, 0.5)',
    border: '1px solid',
    fontWeight: "300",
    padding: "10px 20px",
    borderRadius: "20px",
    borderColor: 'white',
    '&:hover': {
        backgroundColor: 'rgba(16, 42, 116, 1)',
    },
    '&:active': {
        backgroundColor: 'rgba(16, 42, 116, 1)',
    },
}

const sectionMobileOnly = {

    display: {xs: "inherit", sm: "inherit", md: "none",},
}

const sectionCustomMobileOnlyRoof = {
    display: {
        xs: "inherit",
        sm: "inherit",
    },
    "@media (min-width:1100px)": {
        display: "none",
    },
};

const sectionDesktopOnlyRoof = {
    display: {
        xs: "none",
        sm: "none",
    },
    "@media (min-width:1100px)": {
        display: "flex",
    },
};

const sectionDesktopOnly = {

    display: {xs: "none", sm: "none", md: "flex",}
}

const paddingATF = {
    paddingTop: 5,
    paddingBottom: 5,
    paddingLeft: 2,
    paddingRight: 8,
    gap: 1.75,
}

export {
    subtitleBottom,
    whatWeDoCard,
    parentBox,
    darkBlueBox,
    whiteCopy,
    testimonialBox,
    lightBlueBox,
    grayBox,
    whiteBox,
    basicSize,
    basicSizeReverse,
    fiftyFifty,
    fiftyFiftyHidden,
    beforeAfterImage,
    oneHundred,
    vCenter,
    vLeft,
    vRight,
    rightBottom,
    hCenter,
    hLeft,
    hRight,
    paddingMinimal,
    padding1,
    padding2,
    padding3,
    padding4,
    marginEqualPadding4,
    paddingForm,
    twoButton,
    testimonialsStyle,
    youtubeVideo,
    guaranteeBox,
    marginBottomR,
    watchButton,
    sectionMobileOnly,
    sectionDesktopOnly,
    paddingATF,
    twoColor,
    sectionCustomMobileOnlyRoof,
    sectionDesktopOnlyRoof
};
